import React from 'react';
import { connect } from 'react-redux';

import GetStarted from './components/GetStarted';
import SuccessMessage from './components/SuccessMessage';
import Four0Four from './components/Four0Four';
import DocumentTitle from 'react-document-title';
import Dashboard from './components/Dashboard';

import { Switch, Route } from 'react-router-dom';
import { withRouter, Redirect } from 'react-router-dom';
import {
  startRedirect,
  endRedirect,
  authFieldChanged,
  setDeviceType
} from './actions';

//var MobileDetect = require('mobile-detect');
//var md = new MobileDetect(window.navigator.userAgent);

const queryString = require('query-string');


class App extends React.Component {

  componentWillMount() {
    /*
    if(md.os() === "iOS" && md.tablet() == null){
      //redirect app store
      this.props.setDeviceType("ios");
      this.props.startRedirect('https://dealmachine.app.link/redirect')
    }else if(md.os() === "AndroidOS" && md.tablet() == null){
      //redirect play store
      this.props.setDeviceType("android");

      this.props.startRedirect('https://dealmachine.app.link/redirect')
    }else{
      this.props.setDeviceType("desktop");
    }
    */

    const parsed = queryString.parse(this.props.location.search);

    if(parsed._branch_match_id){
      if(parsed._branch_match_id !== ""){
        this.props.authFieldChanged({ prop: "branch_id", value: parsed._branch_match_id });
        window.localStorage.setItem('branch_id', parsed._branch_match_id);

      }
    }

    if(parsed.campaign){
      if(parsed.campaign !== ""){
        this.props.authFieldChanged({ prop: "from_campaign", value: parsed.campaign });
        window.localStorage.setItem('from_campaign', parsed.campaign);

      }
    }
    if(parsed.source){
      if(parsed.source !== ""){
        this.props.authFieldChanged({ prop: "from_source", value: parsed.source });
        window.localStorage.setItem('from_source', parsed.source);

      }
    }



    const saved_branch_id = window.localStorage.getItem('branch_id');
    if(saved_branch_id != null){
      this.props.authFieldChanged({ prop: "branch_id", value: saved_branch_id });
    }

    const saved_from_campaign = window.localStorage.getItem('from_campaign');
    if(saved_from_campaign != null){
      this.props.authFieldChanged({ prop: "from_campaign", value: saved_from_campaign });
    }
    const saved_from_source = window.localStorage.getItem('from_source');
    if(saved_from_source != null){
      this.props.authFieldChanged({ prop: "from_source", value: saved_from_source });
    }

  }

  componentWillReceiveProps(nextProps) {

    if(nextProps.redirectTo != null){
      if (nextProps.redirectTo.indexOf("http://") === 0 || nextProps.redirectTo.indexOf("https://") === 0) {
        window.location.href = nextProps.redirectTo;
      }else{
        this.props.history.push(nextProps.redirectTo);
        this.props.endRedirect();
      }
    }
  }

  renderRedirect(){
    if(this.props.redirectTo){
      if (this.props.redirectTo.indexOf("http://") === 0 || this.props.redirectTo.indexOf("https://") === 0) {
        window.location.href = this.props.redirectTo;
      }else{
        return <Redirect to={this.props.redirectTo} push />;
      }
    }
  }

  renderSuccess(){
    if(this.props.success_message){
      return <SuccessMessage text={this.props.success_message}/>;
    }
  }

  render() {

      return (
        <DocumentTitle title={'Get Paid Explore Your City - DealMachine'}>
          <div className="app-wrapper">
            {/*this.renderRedirect()*/}
            <Switch>
              <Route exact path='/'  component={Four0Four}/>
              <Route path='/dashboard'  component={Dashboard}/>

              <Route exact path='/:id'  component={GetStarted}/>

              <Route path='/' component={Four0Four}/>
            </Switch>
            {this.renderSuccess()}
          </div>
        </DocumentTitle>
      );
    }

}

const mapStateToProps = ({ auth, common, modal }) => {
  const { token, user, device_type, signup_type, signup_team_name, signup_team_company } = auth;
  const { redirectTo } = common;
  const { success_message } = modal;
  return { token, user, device_type, redirectTo, success_message, signup_type, signup_team_name, signup_team_company }
}

export default withRouter(connect(mapStateToProps, { startRedirect, endRedirect, authFieldChanged, setDeviceType })(App));



// WEBPACK FOOTER //
// ./src/App.js